/* Legacy page behaviours. Show/hide, fades, scroll animation, data attributes, ready timing and
   event helpers come from project-unity-fx.js (loaded just before this file), which reproduces the
   jQuery calls these blocks were written with. */
(function (fx) {
var all = fx.all, attr = fx.attr, eq = fx.eq;
var addClass = fx.addClass, removeClass = fx.removeClass, toggleClass = fx.toggleClass;

fx.ready(function()
{
  fx.on(all('.app-how-item'), 'click', function(){
    removeClass(all('.app-how-item'), 'active');
    addClass([this], 'active');
    fx.hide(all('.app-how-images img'));
    fx.show(all('.'+attr(this, 'id')));
  });

  var videos  = all(".video");
  fx.on(videos, "click", function(){
      var elm = this,
          conts   = elm.childNodes,
          le      = conts.length,
          ifr     = null;

      for(var i = 0; i<le; i++){
        if(conts[i].nodeType == 8) ifr = conts[i].textContent;
      }

      addClass([elm], "player");
      elm.innerHTML = ifr === null ? '' : ifr;
      fx.off([elm], null, "click");
    all('iframe', this).forEach(function (iframe) { iframe.click(); });
  });

  fx.on(all('.app-collection-products-page-filter-items-item'), 'click', function(){
    removeClass(all('.app-collection-products-page-filter-items-item'), 'active');
    addClass([this], 'active');

    if(attr(this, 'id') == 'item-all')
    {
      fx.show(all('.app-collection-products-page-content-products-product'));
    }
    else {
      fx.hide(all('.app-collection-products-page-content-products-product'));
      fx.show(all('.'+attr(this, 'id')));
    }
  });


  fx.on(all('.app-go-top'), 'click', function(e) {
    fx.animate(all("html, body"), {scrollTop: 0}, 200);
  });

  fx.on(all('.app-button-more-videos'), 'click', function(e) {
    fx.hide([this]);
    fx.show(all('.app-video-item.second'));
    return false;
  });

fx.ready(function () {
  // Project Unity galleries use a native scroll-snap rail owned by
  // project-unity-product.js. The legacy touch handler below calls
  // preventDefault(), so running both controllers makes mobile swipes fail.
  if (document.querySelector('.pu-product-page [data-product-gallery-track]')) return;

  var thumbs = all('.app-product-container-gallery-secondary img');
  var main = all('.additional-photo .img-fluid, .additional-photo .app-external-video');

  var nav = all('.additional-photo-nav');
  var curNum = all('.additional-photo-current');
  var totalNum = all('.additional-photo-total');

  function syncCounterByThumb(t){
    if(!t) return;
    var idx = thumbs.indexOf(t); // 0-based
    curNum.forEach(function (el) { el.textContent = idx + 1; });
    totalNum.forEach(function (el) { el.textContent = thumbs.length; });

    // если 0 или 1 фото — прячем навигацию
    nav.forEach(function (el) { el.classList.toggle('is-hidden', thumbs.length <= 1); });
  }

  function activate(t) {
    if (!t) return;

    var id = attr(t, 'id'); // img-fluid_3

    fx.hide(main);
    fx.show(all('.additional-photo #' + id));

    removeClass(thumbs, 'active');
    addClass([t], 'active');

    syncCounterByThumb(t);
  }

  function activeThumbs() {
    return thumbs.filter(function (el) { return el.classList.contains('active'); });
  }

  function showNext() {
    if (!thumbs.length) return;
    var idx = thumbs.indexOf(activeThumbs()[0]);
    if (idx < 0) idx = 0;
    var nextI = (idx + 1) % thumbs.length;
    activate(eq(thumbs, nextI)[0]);
  }

  function showPrev() {
    if (!thumbs.length) return;
    var idx = thumbs.indexOf(activeThumbs()[0]);
    if (idx < 0) idx = 0;
    var prevI = (idx - 1 + thumbs.length) % thumbs.length;
    activate(eq(thumbs, prevI)[0]);
  }

  fx.on(thumbs, 'mouseenter', function () {
    activate(this);
  });

  // теперь стрелки — это кнопки внутри пилюли
  fx.on(all('.additional-photo-right'), 'click', function () { showNext(); });
  fx.on(all('.additional-photo-left'), 'click', function () { showPrev(); });

  // SWIPE оставляем как у тебя
  (function addSwipe() {
    var startX = 0, startY = 0;
    var isHorizontal = false, locked = false;
    var INTENT_THRESHOLD = 10;
    var SWIPE_THRESHOLD = 40;
    var area = all('.additional-photo');

    fx.on(area, 'touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      isHorizontal = false;
      locked = false;
    });

    fx.on(area, 'touchmove', function (e) {
      var t = e.touches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;

      if (!locked) {
        if (Math.abs(dx) > INTENT_THRESHOLD || Math.abs(dy) > INTENT_THRESHOLD) {
          locked = true;
          isHorizontal = Math.abs(dx) > Math.abs(dy);
        }
      }
      if (locked && isHorizontal) e.preventDefault();
    });

    fx.on(area, 'touchend', function (e) {
      if (!locked || !isHorizontal) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;
      if (dx < 0) showNext(); else showPrev();
    });
  })();

  // старт
  if (!activeThumbs().length && thumbs.length) {
    activate(eq(thumbs, 0)[0]);
  } else {
    activate(activeThumbs()[0]);
  }
});



  fx.on(all('.product-info-item'), 'click', function() {
    toggleClass([this], 'active');
  })

  fx.on(all('.custom-product-list__toggle-item'), 'click', function(e) {
    var metas = [];
    for (var node = this.parentNode; node && node.nodeType === 1; node = node.parentNode) {
      if (node.matches('.custom-product-card__meta')) metas.push(node);
    }
    var id = attr(this, 'id');
    metas.forEach(function (meta) { fx.hide(all('.custom-product-card__items-item', meta)); });
    metas.forEach(function (meta) { fx.show(all('.'+id, meta)); });
  });


  // Main Slider
  let interval = parseInt(fx.data(document.querySelector('.app-clinic-slider'), 'interval')) || 10000;
  let currentIndex = 0;
  let totalSlides = all('.app-clinic-slider-slide').length;

  function changeSlide(index) {
      // Снимаем все active и скрываем
      var hiding = all('.app-clinic-slider-slide, .app-clinic-grid-slider-image');
      removeClass(hiding, 'active');
      fx.fadeOut(hiding, 500);
      removeClass(all('.app-clinic-slider-chooser-item'), 'active');

      // Показываем нужный слайд
      var slide = eq(all('.app-clinic-slider-slide'), index);
      fx.fadeIn(slide, 500);
      addClass(slide, 'active');
      var image = eq(all('.app-clinic-grid-slider-image'), index);
      fx.fadeIn(image, 500);
      addClass(image, 'active');
      addClass(eq(all('.app-clinic-slider-chooser-item'), index), 'active');

      currentIndex = index;
  }

  function autoSlide() {
      let nextIndex = (currentIndex + 1) % totalSlides;
      changeSlide(nextIndex);
  }

  // Запускаем автослайд
  let autoSlideInterval = setInterval(autoSlide, interval);

  // При смене видимости вкладки
  document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
          clearInterval(autoSlideInterval); // остановить, если вкладка неактивна
      } else {
          autoSlideInterval = setInterval(autoSlide, interval); // перезапустить при возврате
      }
  });

  // Привязываем стрелки
  fx.on(all('.app-clinic-slider-chooser-arrows-items-nav-right'), 'click', function () {
      let nextIndex = (currentIndex + 1) % totalSlides;
      changeSlide(nextIndex);
      resetAutoSlide();
  });

  fx.on(all('.app-clinic-slider-chooser-arrows-items-nav-left'), 'click', function () {
      let prevIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      changeSlide(prevIndex);
      resetAutoSlide();
  });

  // Привязка к кругам
  fx.on(all('.app-clinic-slider-chooser-item'), 'click', function () {
      let index = 0;
      for (var sibling = this.previousElementSibling; sibling; sibling = sibling.previousElementSibling) index++;
      changeSlide(index);
      resetAutoSlide();
  });

  // Сброс автоинтервала после ручного клика
  function resetAutoSlide() {
      clearInterval(autoSlideInterval);
      autoSlideInterval = setInterval(autoSlide, interval);
  }

  fx.hide(all('.app-clinic-slider-slide, .app-clinic-grid-slider-image'));
  fx.show(all('.app-clinic-slider-slide.active, .app-clinic-grid-slider-image.active'));


  fx.on(all('.product__description-title'), 'click', function(e) {
    var next = this.nextElementSibling;
    if (next) toggleClass([next], 'active');
    toggleClass([this], 'active');
  });
});
})(window.PuFx);
